// extracted by mini-css-extract-plugin
export default {"content":"ClientPicker_content__oIONA"};